import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import CertDetails from "../certs/CertDetails";
import EditCert from "../certs/EditCert";
import ConsoleHelper from "../utils/logger";

export const CertNavigation: React.FC = () => {
  let { path } = useRouteMatch();

  ConsoleHelper(path);
  return (
    <Switch>
      <Route exact path={path} render={() => <CertDetails />} />
      <Route path={`${path}/:mailId/edit`} render={() => <EditCert />} />
    </Switch>
  );
};

export default CertNavigation;
